import { isDesktopApp } from './desktop'

// Single capability gate for the ENTIRE local-AI surface (chat panel, improve-with-AI, SVG
// generation, the workflow/dashboard). When this is OFF the UI hides every AI affordance and
// nothing calls the /agent/* endpoints.
//
// The answer is "am I running inside Niobe Desktop?" — `window.niobeDesktop`, injected by
// client/desktop/preload.mjs — and nothing else. Inside the desktop app the passerelle IS this
// page's own origin, so AI is simply available.
//
// A BROWSER is off, and stays SILENT about it. `GET /v1/gateway` can say whether this member has
// a desktop app running *somewhere*, but that is a heartbeat, not an address: the registered URL
// is `http://localhost:4100` on their machine, which this browser may not share. The SPA
// therefore does not consult it at all — a web-only member is not in the middle of a degraded
// desktop session, they are simply using the web app, and telling them about a desktop app they
// may not want is noise on every page. MVP 2 re-enables AI in the browser by making the gateway
// genuinely reachable, not by advertising an unreachable one.

export { isDesktopApp } from './desktop'

/**
 * Reactive gate for React render paths (menus, panels, buttons).
 *
 * True only in the desktop app. A browser cannot reach a gateway bound to another machine's
 * loopback address, so rendering AI controls there would produce buttons that fail on click.
 */
export function useAgentAvailable(): boolean {
  return isDesktopApp()
}

/** Imperative gate for non-render code (e.g. the api.ts backstop, event handlers). */
export function isAgentAvailable(): boolean {
  return isDesktopApp()
}
